import React from 'react';
import { useTranslation } from 'react-i18next';
import { unescapeHTML } from 'underscore.string';
import { NavLink } from 'react-router-dom';
import { Menu } from '@headlessui/react';
import CargomaticLogo from 'img/cargomatic-logo-dark.png';
import SessionStore from 'stores/SessionStore';
import classNames from 'classnames';
import Navbar from '../v2/navs/Navbar';
import UserActionCreators from '../../actions/UserActionCreators';
import DropdownMenu from '../v2/dropdowns/DropdownMenu';
import { Avatar } from '../modules/user/Avatar';
import LanguageSelector from './language-selector';

function logout() {
  UserActionCreators.logout();
}

export default function ConsigneeNavigation() {
  const consignee = SessionStore.getUser();
  const { t } = useTranslation();

  function renderMobileNav(onClose) {
    return [
      <NavLink
        className="nav-item"
        to="/tracking"
        onClick={onClose}
        key="mobile-tracking"
      >
        <span>{t('TRACKING')}</span>
      </NavLink>,
      <NavLink
        className="nav-item"
        to="/appointments"
        onClick={onClose}
        key="appointments-tracking"
      >
        <span>{t('APPOINTMENTS')}</span>
      </NavLink>,
      <NavLink
        className="nav-item"
        to={`/consignee/${consignee?._id}`}
        onClick={onClose}
        key="mobile-profiles"
      >
        <span>{t('MY_PROFILE')}</span>
      </NavLink>,
      <div
        className={classNames('nav-item', {
          hidden: LANGUAGE_SELECTION_DISABLED,
        })}
      >
        <LanguageSelector mobile />
      </div>,
      <a href="#" className="nav-item" onClick={logout} key="mobile-signout">
        {t('SIGN_OUT')}
      </a>,
    ];
  }
  function renderRightNav() {
    const name = SessionStore.getUser().name;
    const userId = SessionStore.getUser()._id;
    let profileButton = null;

    profileButton = (
      <div
        title={unescapeHTML(name)}
        className="flex text-sm bg-gray-800 rounded-full focus:outline-none focus:ring-2 focus:ring-offset-gray-800 focus:ring-white"
        aria-haspopup="true"
      >
        <Avatar
          key={userId}
          userId={userId}
          altName="Logo"
          className="w-8 h-8 rounded-full"
        />
      </div>
    );

    return [
      <div
        className={classNames(
          'flex items-center justify-center nav-item mr-2',
          { hidden: LANGUAGE_SELECTION_DISABLED },
        )}
      >
        <LanguageSelector />
      </div>,
      <DropdownMenu
        title="Carrier Center"
        button={profileButton}
        isDark
        key="main-dropdown"
      >
        <Menu.Item key="profile">
          <NavLink
            activeClassName="active-light"
            className="nav-item"
            to={`/consignee/${consignee?._id}`}
          >
            <span>{t('MY_PROFILE')}</span>
          </NavLink>
        </Menu.Item>
        <Menu.Item key="sign-out">
          <a href="#" className="nav-item" onClick={logout}>
            {t('SIGN_OUT')}
          </a>
        </Menu.Item>
      </DropdownMenu>,
    ];
  }
  const brandLogo = (
    <NavLink to="/">
      <img alt="Cargomatic" src={CargomaticLogo} style={{ height: 25 }} />
    </NavLink>
  );

  return (
    <Navbar
      logo={brandLogo}
      renderRightNav={renderRightNav}
      renderMobileNav={renderMobileNav}
    >
      <NavLink className="nav-item" to="/tracking" key="Tracking">
        <span>{t('TRACKING')}</span>
      </NavLink>
      <NavLink className="nav-item" to="/appointments" key="Appointments">
        <span>{t('APPOINTMENTS')}</span>
      </NavLink>
    </Navbar>
  );
}
